angular.module('bbl.module.line-settings.routing', [])
  .config(['$routeProvider', lineSettingsRoutingSetup]);

function lineSettingsRoutingSetup($routeProvider) {
  var resolveAuth = {
    bridge: ['Api', '$route', function(Api, $route) {
      return Api.bridges.fetchOne($route.current.params.id, {}, {cache: false});
    }],
    userInfo: ["Auth", function(Auth) {
      return Auth.getUserInfo();
    }], permissions: ["Auth", function(Auth) {
      return Auth.getPermission().then(function(response) {
        return response.data.permission_level;
      });
    }]
  };
  
  var lineSettingsRoute = {
    templateUrl: 'line-settings-template.html',
    controller: 'LineSettingsController',
    resolve: resolveAuth
  };

  $routeProvider.when('/settings/:id', lineSettingsRoute);
}


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/line-settings/line-settings.routing.js
 ** module id = 347
 ** module chunks = 0
 **/